<div class="safe-area">
  <h3 class="title">{{ "Review Your Resume" | translate }}</h3>
  <div class="row mx-2 mx-lg-5">
    <div class="col-12 col-md-5 col-lg-4 order-2 order-md-1">
      <h5 class="title">{{ "Download" | translate }}</h5>
      <ng-container *ngIf="!loadingPurchaseStatus">
        <!-- If neither product is purchased, show payment buttons -->

        <div *ngIf="!isPdfPurchased && !isWordPurchased">
          <div class="row pdf" (click)="goToPayment('generate-cv-pdf')">
            <p class="col m-0 d-flex align-items-center justify-content-center">
              <img src="./assets/icon/pdf.png" />
              <span>{{ "Purchase PDF" | translate }}</span>
            </p>
            <p class="price col-auto">150 LE</p>
          </div>
          <div class="row word" (click)="goToPayment('generate-cv-word')">
            <p
              class="col m-0 text-center d-flex align-items-center justify-content-center"
            >
              <img src="./assets/icon/pdf.png" />
              <img src="./assets/icon/word.png" />

              <span class="px-1">{{
                "Purchase PDF and Word" | translate
              }}</span>
            </p>
            <p class="price col-auto">250 LE</p>
          </div>
        </div>

        <!-- If purchased, show download buttons styled as before -->
        <div *ngIf="isPdfPurchased || isWordPurchased">
          <div class="row pdf align-items-center" *ngIf="isPdfPurchased">
            <p class="col m-0 d-flex align-items-center justify-content-center">
              <img src="./assets/icon/pdf.png" />
              <span class="ms-2">{{ "Download as PDF" | translate }}</span>
            </p>
            <p class="price col-auto m-0">
              <button
                class="btn btn-outline-primary download-btn"
                (click)="onDownload('pdf')"
              >
                {{ "Download" | translate }}
              </button>
            </p>
          </div>
          <div class="row word align-items-center" *ngIf="isWordPurchased">
            <p class="col m-0 d-flex align-items-center justify-content-center">
              <img src="./assets/icon/word.png" />
              <span class="ms-2">{{ "Download as Word" | translate }}</span>
            </p>
            <p class="price col-auto m-0">
              <button
                class="btn btn-outline-success download-btn"
                (click)="onDownload('word')"
              >
                {{ "Download" | translate }}
              </button>
            </p>
          </div>
        </div>
      </ng-container>
    </div>
    <img [src]="safeUrl" class="col-12 col-md-7 col-lg-8 order-1 order-md-2" />
  </div>
</div>
<div class="next-container px-4">
  <button class="border-button m-3" (click)="onPrevious()">
    {{ "Back" | translate }}
  </button>
</div>
